"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _search = require("../../clients/search.client");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _mapKeys2 = _interopRequireDefault(require("lodash/mapKeys"));
var _itinerary = require("../../utils/itinerary.utils");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _searchResults = require("../../utils/search-results.utils");
var _searchRequest = _interopRequireDefault(require("../../factories/search-request.factory"));
var _brandedFares = require("../../factories/branded-fares.factory");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _constants2 = require("../../constants");
var _fareFamilies = _interopRequireDefault(require("../fare-families.store"));
var _group = _interopRequireWildcard(require("../../utils/group.utils"));
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var AsyncSearchResultsStore = exports.default = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, (_class = function () {
  function AsyncSearchResultsStore(initialState, $env) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, AsyncSearchResultsStore);
    this.$env = void 0;
    this.requestData = null;
    this.fareFamilies = void 0;
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "allFilters", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "searchQuery", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "showAgentResults", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "POLLING_STATE", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "DATA_SOURCE", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "initialSearchPayload", _descriptor7, this);
    (0, _initializerDefineProperty2.default)(this, "propertyWeightMap", _descriptor8, this);
    this.countFlightsByAirline = (0, _mobxUtils.computedFn)(function (airlineCode) {
      return (0, _searchResults.getNumberOfFlightsByAirlineCode)(_this.itineraries, airlineCode);
    });
    this.countFlightsWithBaggageOptionsByAirline = (0, _mobxUtils.computedFn)(function (airlineCode) {
      return (0, _searchResults.getNumberOfFlightsWithOptionByAirlineCode)(_this.itineraries, airlineCode);
    });
    this.getFlightCountsByBaggage = (0, _mobxUtils.computedFn)(function (airlineCode) {
      return (0, _searchResults.getNumberOfDifferentBaggageOption)(_this.itineraries, airlineCode);
    });
    (0, _initializerDefineProperty2.default)(this, "getInitialSearchPayload", _descriptor9, this);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.fareFamilies = new _fareFamilies.default({}, $env);
    (0, _mobx.reaction)(function () {
      return _this.isLoading;
    }, function (isLoading) {
      isLoading && _this.fareFamilies.reset();
    });
    (0, _mobx.reaction)(function () {
      return {
        length: _this.data.length,
        brandedFaresMap: _this.brandedFaresMap
      };
    }, function (_ref) {
      var length = _ref.length,
        brandedFaresMap = _ref.brandedFaresMap;
      !!length && _this.fareFamilies.syncData(_this.searchResults.itineraryHashMap, brandedFaresMap, _this.searchRequest);
    });
  }
  (0, _createClass2.default)(AsyncSearchResultsStore, [{
    key: "isLoading",
    get: function get() {
      return this.POLLING_STATE === _constants.POLLING_STATE.POLLING_RETRY || this.POLLING_STATE === _constants.POLLING_STATE.POLLING_START;
    }
  }, {
    key: "isFetched",
    get: function get() {
      return this.POLLING_STATE === _constants.POLLING_STATE.POLLING_IN_PROGRESS;
    }
  }, {
    key: "isCompleted",
    get: function get() {
      return this.POLLING_STATE === _constants.POLLING_STATE.POLLING_END;
    }
  }, {
    key: "hasError",
    get: function get() {
      return this.POLLING_STATE === _constants.POLLING_STATE.POLLING_FAILED;
    }
  }, {
    key: "isCached",
    get: function get() {
      return this.DATA_SOURCE === _constants.DATA_SOURCES.CACHE;
    }
  }, {
    key: "config",
    get: function get() {
      return {
        showAgentResults: this.showAgentResults
      };
    }
  }, {
    key: "combinedSearchResults",
    get: function get() {
      return (0, _searchResults.mergeSearchResultsChunks)(this.data);
    }
  }, {
    key: "searchResults",
    get: function get() {
      return (0, _searchResults.formatSearchResults)({
        searchResults: this.combinedSearchResults,
        searchRequest: this.searchRequest,
        $currency: this.$env.currency,
        config: this.config
      });
    }
  }, {
    key: "searchRequest",
    get: function get() {
      return (0, _searchRequest.default)(this.searchQuery);
    }
  }, {
    key: "searchCabin",
    get: function get() {
      return this.searchRequest.preferredCabin;
    }
  }, {
    key: "itineraryHashMap",
    get: function get() {
      return this.searchResults.itineraryHashMap;
    }
  }, {
    key: "itineraryLegHashMap",
    get: function get() {
      return (0, _itinerary.generateItineraryLegHashMap)(this.itineraries);
    }
  }, {
    key: "legHashMap",
    get: function get() {
      return this.searchResults.legHashMap;
    }
  }, {
    key: "segmentHashMap",
    get: function get() {
      return this.searchResults.segmentHashMap;
    }
  }, {
    key: "itineraryPropertyKeys",
    get: function get() {
      return (0, _keys2.default)(this.propertyWeightMap);
    }
  }, {
    key: "includedItineraries",
    get: function get() {
      return (0, _filter2.default)(this.itineraryHashMap, function (_ref2) {
        var isExcluded = _ref2.isExcluded;
        return !isExcluded;
      });
    }
  }, {
    key: "getItinerary",
    get: function get() {
      var _this2 = this;
      return function (itineraryId) {
        var _this2$fareFamilies$f;
        return (_this2$fareFamilies$f = _this2.fareFamilies.fareFamilyItinerary(itineraryId)) !== null && _this2$fareFamilies$f !== void 0 ? _this2$fareFamilies$f : _this2.itineraryHashMap[itineraryId];
      };
    }
  }, {
    key: "propertyValuesRangeMap",
    get: function get() {
      return (0, _itinerary.getPropertyValuesRangeMap)(this.includedItineraries, this.itineraryPropertyKeys);
    }
  }, {
    key: "itineraries",
    get: function get() {
      return (0, _itinerary.addScoreToItineraries)({
        itineraries: this.includedItineraries,
        allFilters: (0, _mobx.toJS)(this.allFilters)
      });
    }
  }, {
    key: "groupedItineraries",
    get: function get() {
      return (0, _group.itineraryGroupMap)((0, _group.default)(this.itineraries, _constants2.DEFAULT_GROUP_PATHS, _constants2.MIN_GROUP_LENGTH));
    }
  }, {
    key: "itinerariesPathMap",
    get: function get() {
      return (0, _mapKeys2.default)(this.itineraries, function (itinerary) {
        return itinerary.path;
      });
    }
  }, {
    key: "outboundItineraries",
    get: function get() {
      return (0, _filter2.default)(this.itineraries, function (itinerary) {
        return itinerary.direction === 'outbound';
      });
    }
  }, {
    key: "inboundItineraries",
    get: function get() {
      return (0, _filter2.default)(this.itineraries, function (itinerary) {
        return itinerary.direction === 'inbound';
      });
    }
  }, {
    key: "legs",
    get: function get() {
      return (0, _values2.default)(this.legHashMap);
    }
  }, {
    key: "segments",
    get: function get() {
      return (0, _values2.default)(this.segmentHashMap);
    }
  }, {
    key: "airportCodes",
    get: function get() {
      return (0, _searchResults.extractSearchAirportCodes)({
        searchRequest: this.searchRequest,
        segments: this.segments
      });
    }
  }, {
    key: "airlineCodes",
    get: function get() {
      return (0, _searchResults.extractSearchAirlineCodes)(this.segments);
    }
  }, {
    key: "itinerariesWithLimitedSeatsCount",
    get: function get() {
      return (0, _itinerary.getFlightsCountsWithLimitedSeat)(this.itineraries, _constants2.MAX_SEAT_COUNT);
    }
  }, {
    key: "resourceCodes",
    get: function get() {
      return [].concat(this.airportCodes, this.airlineCodes);
    }
  }, {
    key: "brandedFares",
    get: function get() {
      return (0, _flatMap2.default)(this.data, function (response) {
        return (0, _map2.default)(response === null || response === void 0 ? void 0 : response.res, function (chunk) {
          var _chunk$data$brandedFa, _chunk$data;
          return (_chunk$data$brandedFa = chunk === null || chunk === void 0 ? void 0 : (_chunk$data = chunk.data) === null || _chunk$data === void 0 ? void 0 : _chunk$data.brandedFares) !== null && _chunk$data$brandedFa !== void 0 ? _chunk$data$brandedFa : {};
        });
      });
    }
  }, {
    key: "brandedFaresMap",
    get: function get() {
      var _this3 = this;
      var rawMap = _merge2.default.apply(void 0, [{}].concat(this.brandedFares));
      return (0, _mapValues2.default)(rawMap, function (fares, code) {
        return (0, _brandedFares.brandedFaresFactory)({
          fares: fares,
          code: code,
          $currency: _this3.$env.currency
        });
      });
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "fetch",
    value: function fetch(_ref3) {
      var _this4 = this;
      var query = _ref3.query,
        _ref3$errorHandler = _ref3.errorHandler,
        errorHandler = _ref3$errorHandler === void 0 ? function () {
          return null;
        } : _ref3$errorHandler,
        _ref3$isTravelPort = _ref3.isTravelPort,
        isTravelPort = _ref3$isTravelPort === void 0 ? false : _ref3$isTravelPort,
        _ref3$sortingLogic = _ref3.sortingLogic,
        sortingLogic = _ref3$sortingLogic === void 0 ? _constants2.DEFAULT_SORTING_LOGIC : _ref3$sortingLogic,
        _ref3$singleTicketing = _ref3.singleTicketing,
        singleTicketing = _ref3$singleTicketing === void 0 ? false : _ref3$singleTicketing;
      this.data = [];
      this.searchQuery = query;
      this.POLLING_STATE = _constants.POLLING_STATE.POLLING_RETRY;
      _search.SearchClient.getAsyncSearchResults(query, isTravelPort, sortingLogic, singleTicketing, this.initialSearchPayload).on('start', function (data) {
        return _this4.onPollingStart(data);
      }).on('data', function (data) {
        return _this4.onSuccess(data);
      }).on('error', function (error) {
        return _this4.onError(error, errorHandler);
      }).on('end', function () {
        return _this4.onPollingEnd();
      });
    }
  }, {
    key: "onPollingStart",
    value: function onPollingStart(data) {
      this.requestData = data.request;
      this.initialSearchPayload = null;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(data) {
      var _data$allFilters;
      this.POLLING_STATE = _constants.POLLING_STATE.POLLING_IN_PROGRESS;
      var _data = (0, _itinerary.addAirlineToFareFamilyKeys)(data);
      this.data.push(_data);
      this.allFilters = (_data$allFilters = _data === null || _data === void 0 ? void 0 : _data.allFilters) !== null && _data$allFilters !== void 0 ? _data$allFilters : {};
    }
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      if (!error.__CANCEL__) {
        this.POLLING_STATE = _constants.POLLING_STATE.POLLING_FAILED;
        errorHandler(error);
      }
    }
  }, {
    key: "onPollingEnd",
    value: function onPollingEnd() {
      this.DATA_SOURCE = _constants.DATA_SOURCES.NETWORK;
      this.POLLING_STATE = _constants.POLLING_STATE.POLLING_END;
    }
  }, {
    key: "resetData",
    value: function resetData() {
      this.POLLING_STATE = _constants.POLLING_STATE.POLLING_RETRY;
      this.data = [];
      this.allFilters = {};
      this.searchQuery = '';
    }
  }, {
    key: "setData",
    value: function setData(data) {
      if ((0, _has2.default)(data, 'data') && (0, _has2.default)(data, 'requestData')) {
        var _data$requestData$que, _data$requestData;
        this.data = data.data;
        this.allFilters = (0, _get2.default)((0, _last2.default)(this.data), 'allFilters', {});
        this.searchQuery = (_data$requestData$que = data === null || data === void 0 ? void 0 : (_data$requestData = data.requestData) === null || _data$requestData === void 0 ? void 0 : _data$requestData.query) !== null && _data$requestData$que !== void 0 ? _data$requestData$que : '';
        this.DATA_SOURCE = _constants.DATA_SOURCES.CACHE;
        this.POLLING_STATE = _constants.POLLING_STATE.POLLING_END;
      } else {
        this.POLLING_STATE = _constants.POLLING_STATE.POLLING_FAILED;
      }
    }
  }, {
    key: "setPropertyWeightMap",
    value: function setPropertyWeightMap(nextPropertyWeightMap) {
      this.propertyWeightMap = nextPropertyWeightMap;
    }
  }, {
    key: "setShowAgentResults",
    value: function setShowAgentResults(showAgentResults) {
      this.showAgentResults = showAgentResults;
    }
  }, {
    key: "setInitialSearchPayload",
    value: function setInitialSearchPayload(data) {
      this.initialSearchPayload = data;
    }
  }]);
  return AsyncSearchResultsStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allFilters", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "showAgentResults", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "POLLING_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.POLLING_STATE.POLLING_START;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "DATA_SOURCE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DATA_SOURCES.NETWORK;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialSearchPayload", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "propertyWeightMap", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants2.FLIGHT_PROPERTY_WEIGHT_MAP;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCompleted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCompleted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCached", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCached"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "config", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "config"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "combinedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "combinedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRequest", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRequest"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchCabin", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchCabin"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryLegHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryLegHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "legHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "legHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "segmentHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "segmentHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryPropertyKeys", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryPropertyKeys"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "includedItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "includedItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getItinerary", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "getItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "propertyValuesRangeMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "propertyValuesRangeMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupedItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerariesPathMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerariesPathMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "outboundItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "outboundItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "inboundItineraries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "inboundItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "legs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "legs"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "segments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "segments"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "airportCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "airportCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "airlineCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "airlineCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerariesWithLimitedSeatsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerariesWithLimitedSeatsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resourceCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resourceCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "brandedFares", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandedFares"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "brandedFaresMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandedFaresMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "fetch"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onPollingStart", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onPollingStart"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onPollingEnd", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onPollingEnd"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetData", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "resetData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setData", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setPropertyWeightMap", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPropertyWeightMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setShowAgentResults", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowAgentResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setInitialSearchPayload", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInitialSearchPayload"), _class.prototype), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getInitialSearchPayload", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function getInitialSearchPayload(_ref4) {
      var _this5 = this;
      var query = _ref4.query,
        timeOut = _ref4.timeOut;
      return _regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _search.SearchClient.getInitialAsyncSearchPayload(query, false, false, timeOut);
            case 3:
              response = _context.sent;
              _this5.setInitialSearchPayload(response);
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              _this5.setInitialSearchPayload(null);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      })();
    });
  }
})), _class));